/**
 *
 * Asynchronously loads the component for AssignmentDetails
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/ui/graphql/AssignmentDetails/loadable.js